import BaseObject from './BaseObject';
import { Matrix4, Mesh } from 'three';
import { ElasticObjectDescription, MaterialTypes, ObjectDescription, ObjectTypes } from '@data/models';
import { GeometryProvider, MaterialsProvider } from '@data/providers';
import { WebGLScene } from '../WebGLScene';
import { Dictionary } from '@types';


class ElasticObject extends BaseObject {
  constructor(mesh: Mesh) {
    super(mesh, ObjectTypes.Biteramp);
  }

  static async create(
    description: ElasticObjectDescription,
    scene: WebGLScene,
    geometryProvider: GeometryProvider,
    materialsProvider: MaterialsProvider
  ) {
    const mesh = new Mesh(
      geometryProvider.getGeometryByDescription(description),
      materialsProvider.getMaterial(MaterialTypes.Elastic, undefined, description.jaw)
    );

    const position = mesh.position.clone();
    const rotation = mesh.rotation.clone();
    const scale = mesh.scale.clone();

    if (description.transform) {
      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      mesh.applyMatrix4(matrix);
    }

    const obj = new ElasticObject(mesh);
    obj.setInitial(position, rotation, scale);
    scene.getRootObject().add(obj.mesh);

    obj.id = description.id;
    obj.visible = description.visible;

    return obj;
  }

  async update (description: ObjectDescription, objects: Dictionary<BaseObject>) {
    if (description.transform) {
      this.resetTransformation();

      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      this._mesh.applyMatrix4(matrix);
    } else {
      this.resetTransformation();
    }

    this._mesh.visible = description.visible;
  }
}

export default ElasticObject;
